<template>
  <div class="questao mb-5">
    <div class="img-questao text-center" v-if="questao.imagem">
      <img :src="questao.imagem" alt="Texto explicando imagem detalhadamente" class="img-fluid" />
    </div>
    <p class="enunciado mt-4 mb-3" v-html="questao.enunciado"></p>
    <div class="respostas mt-2">
      <textarea class="form-control" placeholder="Escreva sua resposta aqui." rows="6"></textarea>
    </div>
    <div class="btns-prev-next">
      <a href="javascript:void(0)" @click="responder()" class="btn btn-step mr-3" :class="{disabled: this.questao.opcaoEscolhida}">Responder</a>
      <a href="javascript:void(0)" @click="verResposta()" class="btn btn-step mr-3" v-if="questao.respostaUsuario">Ver resposta</a>
    </div>
    <div class="comentario gabarito" v-if="questao.respostaUsuario && mostrarGabarito">
      <p>Gabarito</p>
      <div>
        <p v-html="questao.resposta"></p>
      </div>
    </div>
    <div class="comentario mt-4" v-if="questao.respostaUsuario && questao.comentario && hideComentario">
      <p>Comentário</p>
      <div>
        <p v-html="questao.comentario"></p>
        <div class="mt-3" v-if="false">
          <a href="#" data-toggle="modal" data-target="#modalComentario"><i class="fas fa-image"></i> nome da imagem</a>
          <a href="#" data-toggle="modal" data-target="#modalComentario"><i class="fab fa-youtube"></i> nome do video</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopicoQuestaoDiscursiva',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      alerta: {
        variant: '',
        mensagem: '',
        visivel: false
      },
      respostaQuestao: [],
      questao: { id: 0, enunciado: '', opcoes: [], titulo: '', comentario: '', resposta: '', respostaUsuario: '', imagem: '' },
      mostrarGabarito: false
    }
  },
  mounted () {
    this.obterTopico()
  },
  methods: {
    obterTopico: function () {
      this.questao = {
        id: this.ementaCurso.topico_escolhido.ementa_id,
        enunciado: this.ementaCurso.topico_escolhido.enunciado,
        titulo: this.ementaCurso.topico_escolhido.titulo,
        comentario: this.ementaCurso.topico_escolhido.comentario_professor,
        resposta: this.ementaCurso.topico_escolhido.gabarito,
        respostaUsuario: this.ementaCurso.topico_escolhido.resposta,
        imagem: this.ementaCurso.topico_escolhido.imagem
      }

      this.respostaUsuario = [this.ementaCurso.topico_escolhido.opcao_respondida]
    },
    verResposta: function () {
      this.mostrarGabarito = true
    }
  },
  watch: {
    ementaCurso: function () {
      this.obterTopico()
    }
  },
  computed: {
    hideComentario: function () {
      if (this.questao.comentario || this.questao.imagensComentario.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>
